import styles from '../../assets/styles/Transactions/TransactionQuickLinks.module.scss';
import { QuickLinksComponent as QLC } from '../../components/Home';
import { MimaText } from '../../components';
import React from 'react';

const TransactionQuickLinksCard = ({ modalConstant, openModalHandler }) => {
	return (
		<div className={styles.ql}>
			<MimaText variant="bodyBold">Quick Links</MimaText>
			{/* <nav className={styles.ql__content}>
				<QLC title="Add Income" onClick={incomeModal} />
				<QLC title="Add Expense" onClick={expenseModal} />
				<QLC title="Add Debt" onClick={debtModal} />
			</nav> */}
			<nav className={styles.ql__content}>
				<QLC title="Add Income" onClick={
					() => {
						openModalHandler(modalConstant.addIncome)
					}
				} />
				<QLC title="Add Expense" onClick={
					() => {
						openModalHandler(modalConstant.addExpense)
					}
				} />
				<QLC title="Add Debt" onClick={
					() => {
						openModalHandler(modalConstant.addDebt)
					}
				} />
			</nav>
		</div>
	);
};

export default TransactionQuickLinksCard;
